import React from 'react';
import { DayReport } from './pages/DayReport';

export function DayReports({ setActiveItem }: { setActiveItem: (item: string) => void }) {
  return <DayReport setActiveItem={setActiveItem} />;
}
